import React from "react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="bg-[#FFF8E7]" data-testid="page-about">
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <img
          src="/divergent-cinema-logo.png"
          alt="Divergent Cinema Film Festival logo"
          className="h-40 md:h-52 w-auto object-contain mb-10"
          data-testid="about-logo"
        />
        <div className="text-sm uppercase tracking-[0.2em] font-bold text-[#1A5DFF] mb-4">About</div>
        <h1 className="font-heading font-black text-[#0A0A0A] text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
          We&apos;re a small CIC with a clear job.
        </h1>
        <div className="mt-10 space-y-6 text-[#0A0A0A] text-lg leading-relaxed">
          <p>
            Divergent Cinema CIC is a UK-registered Community Interest Company founded by parents of autistic, ADHD and dyslexic filmmakers who were tired of waiting for the industry to catch up.
          </p>
          <p>
            We do four things: programme films, pay artists, run a directory of trustworthy ND professionals, and publish open accessibility guidance for crew, casting and post.
          </p>
          <p>
            Membership is pay-what-you-can with a minimum <strong>£10 per annum</strong>. 100% of fees go to artist honoraria, submission fee waivers and festival travel for the artists we platform.
          </p>
          <p>
            There is also an option to make <strong>additional donations</strong> to support the CIC in film productions and administration costs.
          </p>
        </div>
        <div className="mt-12 flex flex-col sm:flex-row gap-4">
          <Link to="/films" className="bg-[#FF2E63] text-[#FFF8E7] hover:bg-[#E0204F] rounded-none px-6 py-3 font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#FF2E63]">Watch the programme</Link>
          <Link to="/" className="bg-transparent border-2 border-[#0A0A0A] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-[#FFF8E7] rounded-none px-6 py-3 font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0A0A0A]">Back home</Link>
        </div>
      </section>
    </div>
  );
}
